export default __webpack_public_path__ + "static/media/feedback.8482a6ae.png";